import { FC } from "react"
import { cn } from "../../utils"

type Props = {
  count: number
  max: number
  className?: string
  hideText?: boolean
}

const UsageBadge: FC<Props> = ({
  count,
  max,
  className = "",
  hideText = false
}) => {
  const safeCount = Math.max(0, Math.min(count ?? 0, max ?? 0))
  const isAtLimit = safeCount >= max
  const base = "inline-flex items-center rounded-full px-3 py-1.5 text-xs"
  const color = isAtLimit ? "bg-red-300 text-white" : "bg-[#42405A] text-white"

  return (
    <span
      className={cn(base, color, className)}
      aria-label={`Usage ${safeCount} of ${max}`}
    >
      {safeCount}/{max} {hideText ? "" : "Used"}
    </span>
  )
}

export default UsageBadge
